_ = require 'underscore'

module.exports = class NonPublicMixin
  # Key on the attributes that the nonPublic attributes reside in
  nonPublicKey: 'nonPublic'

  # An array of the attributes to replace by their nonPublic versions
  # E.g. ['fullName', 'avatarUrl']
  # To be overridden on the consuming class that it's mixed into
  nonPublicFields: null

  # ===========================
  # Private helper methods
  # ===========================

  # Let's make sure the nonPublicFields field is set
  _isNonPublicFieldsSet: ->
    if !@nonPublicFields?
      console.warn 'Using NonPublicMixin without a nonPublicFields mapping'
    return @nonPublicFields?

  # Mixins can't access the super class so find it on the class constructor
  _superMethod: (method, args...) ->
    @constructor.__super__[method].apply this, args

  # ===========================
  # Overriding methods
  # ===========================

  # Override the get method on the model.
  # Return the nonPublic version of the attribute if it exists.
  get: (attr, isOverrideEnabled = true) ->
    if isOverrideEnabled && @_isNonPublicFieldsSet() && attr in @nonPublicFields
      nonPublicValues = @_superMethod('get', @nonPublicKey) ? []
      if (value = nonPublicValues[attr])?
        return value

    @_superMethod 'get', attr

  # Override the toJSON method of the model
  toJSON: ->
    attributes = @_superMethod 'toJSON'

    if @_isNonPublicFieldsSet()
      attributes = @handleNonPublicFields attributes

    attributes

  # ===========================
  # Class instance helper methods
  # ===========================

  # Take a data model and replace its fields with the nonPublic
  # equivalent, the nonPublic fields will either be looked for on the
  # data provided, or strictly in the nonPublicFields array passed in as
  # the third argument.
  handleNonPublicFields: (data, fields = [], nonPublicFields = []) ->
    if fields.length == 0
      fields = @nonPublicFields

    if nonPublicFields.length == 0 && data[@nonPublicKey]?
      nonPublicFields = data[@nonPublicKey]

    fields.forEach (field) ->
      if (value = nonPublicFields[field])?
        data[field] = value

    data
